export default "<p>\n  user-menu works!\n</p>\n";